import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from '../store';

interface ConciergeReportState {
  handleConciergeReportsCall: boolean;
  mode: string;
  isClient: boolean;
  showUpload: boolean;
}

const initialState: ConciergeReportState = {
  handleConciergeReportsCall: false,
  mode: 'Accessed',
  isClient: false,
  showUpload: false,
};

const conciergeReportSlice = createSlice({
  name: 'conciergeReport',
  initialState,
  reducers: {
    setHandleConciergeReportsCall(state, action: PayloadAction<boolean>) {
      state.handleConciergeReportsCall = action.payload;
    },
    setMode(state, action: PayloadAction<string>) {
      state.mode = action.payload;
      state.isClient = action.payload == 'Accessed';
    },
    setShowUpload(state, action: PayloadAction<boolean>) {
      state.showUpload = action.payload;
    },
  },
});

export const {setHandleConciergeReportsCall, setMode, setShowUpload} =
  conciergeReportSlice.actions;

export const handleConciergeReportsCall = (state: RootState) =>
  state.conciergeReport.handleConciergeReportsCall;

export default conciergeReportSlice.reducer;
